import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setHovered, toggleMobileView, doSearch, setSort } from './actions';
import SearchListComponent from './search-list-component';
import SearchFilters from './search-filters';
import AttractionsMapComponent from '../global/attractions-map-component';
import { LOCAL_KEYS } from '../../constants/localStorageKeys';

const mapStateToProps = (state) => ({
  search: state.Search,
});

const cssMobileShow = "mobile-show";

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mapMobile: false,
      sortValue: props.search.sort,
      width: window.innerWidth,
      bannerSrc: '',
      bannerLink: ''
    };

    this.getInitialFilterValues = this.getInitialFilterValues.bind(this);
    this.getMapCenter = this.getMapCenter.bind(this);
  }

  getInitialFilterValues = () => {
    const { filters } = this.props.search;
    const initialFilterValues = localStorage.getItem(LOCAL_KEYS.FILTER_VALUES);
    return initialFilterValues ? JSON.parse(initialFilterValues) : filters;
  };

  getMapCenter = () => {
    const { search } = this.props;
    let mapCenter = search.mapCenter;

    if (!mapCenter) {
      const { lat, lng } = search.filters.geometry;
      if (!!lat && !!lng) mapCenter = [lat, lng];
    }

    return mapCenter;
  };

  componentWillMount() {
    let { search, dispatch } = this.props;
    if (search.results.length === 0) {
      dispatch(doSearch(this.getInitialFilterValues()));
    }
    let searchbar = document.querySelector('#ajaxsearchlite1 input[name="phrase"]')
    if (searchbar) { searchbar.setAttribute('value', values.text); }
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentDidMount() {
    this.getWpBanner();
  }

  getWpBanner() {
    var wpEndpoint = `${window.location.origin}/wp-json/acf/v3/pages/181`;
    fetch(wpEndpoint)
      .then((response) => response.json())
      .then((json) => {
        if (json && json.acf) {
          var images = json.acf.featured_banner;
          if (images && images.length > 0) {
            var imageIndex = Math.floor(Math.random() * images.length);
            var randomImage = images[imageIndex];
            this.setState({
              bannerSrc: randomImage.image,
              bannerLink: randomImage.link,
            });
          }
        }
      })
      .catch((err) => {
        //do nothing.
      });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  parseQueryString = (params) => {
    let { search } = this.props;
    let values = search.filters;
    values.text = params.get('q') || '';
    if (params.get('rad')) values.rad = params.get('rad');
    if (params.get('lat')) values.lat = params.get('lat');
    if (params.get('long')) values.long = params.get('long');
    return values;
  };

  handleHover = (id) => {
    this.props.dispatch(setHovered(id));
  };

  handleHoverExit = () => {
    this.props.dispatch(setHovered(undefined));
  };

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  sort = (e) => {
    let { dispatch } = this.props;
    this.setState({ sortValue: e.target.value });
    dispatch(setSort(e.target.value));
  };

  search = (values) => {
    let { dispatch } = this.props;
    dispatch(doSearch(values));
  };

  toggleMobileView = () => {
    this.props.dispatch(toggleMobileView());
  };

  renderNoResults = () => {
    let { search } = this.props;
    let { width } = this.state;
    let isMobile = width < 768;
    var displayMessage = search.searchComplete
      ? "There are currently no listings near your desired location. Please check back soon, as new listings are added frequently."
      : "Loading search results...";
    return (
      <div>
        <div className="row">
          <div className="col-12 col-md-3">
            <h2 className="search-filter-txt-head">Search Filter</h2>
            <SearchFilters doSearch={this.search} />
          </div>
          {(!isMobile || (isMobile && !this.props.search.mapMobile)) && (
            <div
              className={`results-container ${
                search.mapMobile ? "mobile-hide" : cssMobileShow
              } col-12 col-md-4`}
            >
              {" "}
              {/* ` For Chrome debugging*/}
              {displayMessage}
            </div>
          )}
          {(!isMobile || (isMobile && this.props.search.mapMobile)) && (
            <div
              className={`map-container ${
                search.mapMobile ? cssMobileShow : "mobile-hide pl-lg-0"
              } col-12 col-md-5 search-map-main`}
            >
              {" "}
              {/* ` For Chrome debugging*/}
              <div id="places-results" />
              <AttractionsMapComponent
                center={this.getMapCenter()}
                listings={[]}
                dates={search.filters.dates}
                zoom="9"
                fullscreen={this.props.search.mapMobile}
                underLocalAttrations
              />
            </div>
          )}
        </div>
        <div className="list-map-toggle">
          <div onClick={() => this.toggleMobileView()}>
            {search.mapMobile ? (
              <span>
                <i className="fas fa-list"></i> List
              </span>
            ) : (
              <span>
                <i className="fas fa-map"></i> Map
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  renderResults = () => {
    let { search } = this.props;
    let { width } = this.state;
    let isMobile = width < 768;
    let { bannerSrc, bannerLink } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-12 col-md-3">
            <h2 className="search-filter-txt-head">Search Filter</h2>
            <SearchFilters doSearch={this.search} />
          </div>
          {(!isMobile || (isMobile && !this.props.search.mapMobile)) && (
            <div
              className={`results-container ${
                this.props.search.mapMobile ? "mobile-hide" : cssMobileShow
              } col-12 col-md-4`}
            >
              {" "}
              {/* ` For Chrome debugging*/}
              <div className="row sort-bar">
                <div className="col pr-0">
                  ({search.results.length} results)
                </div>
                <div className="col">
                  <div className="float-left">
                    <label>
                      <select value={this.state.sortValue} onChange={this.sort}>
                        <option value="" disabled>
                          Sort By
                        </option>
                        <option value="price">Price (lowest to highest)</option>
                        <option value="rating">
                          Rating (highest to lowest)
                        </option>
                      </select>
                      <i className="fas fa-long-arrow-alt-up"></i>
                      <i className="fas fa-long-arrow-alt-down"></i>
                    </label>
                  </div>
                </div>
              </div>
              <SearchListComponent
                listings={search.results}
                dates={search.filters.dates}
                mouseEnter={this.handleHover}
                mouseLeave={this.handleHoverExit}
              />
            </div>
          )}
          {(!isMobile || (isMobile && this.props.search.mapMobile)) && (
            <div
              className={`map-container ${
                this.props.search.mapMobile ? cssMobileShow : "mobile-hide pl-0"
              } col-12 col-md-5 search-map-main`}
            >
              {" "}
              {/* ` For Chrome debugging*/}
              <div id="places-results" />
              <AttractionsMapComponent
                center={this.getMapCenter()}
                listings={search.results}
                dates={search.filters.dates}
                zoom="7"
                fullscreen={this.props.search.mapMobile}
                underLocalAttrations
              />
              {/* Wordpress banner */}
              <div className="cw-wp-banner">
                <a href={bannerLink}>
                  <img
                    className="img-fluid cw-wp-banner-img"
                    src={bannerSrc}
                  ></img>
                </a>
              </div>
            </div>
          )}
        </div>
        <div className="list-map-toggle">
          <div onClick={() => this.toggleMobileView()}>
            {this.props.search.mapMobile ? (
              <span>
                <i className="fas fa-list"></i> List
              </span>
            ) : (
              <span>
                <i className="fas fa-map"></i> Map
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    let { search } = this.props;

    const searchRender =
      !search.searchComplete || !search.results || !search.results.length
        ? this.renderNoResults
        : this.renderResults;

    return (
      <div className="container-fluid search-container">
        {search.filters &&
        search.filters.geometry &&
        search.filters.geometry.locationName ? (
          <p className="filter-search-title">
            Search Results for: {search.filters.geometry.locationName}
          </p>
        ) : null}
        {/* <SearchFilters doSearch={this.search} /> */}
        {searchRender()}
      </div>
    );
  }
}

export default connect(mapStateToProps)(Search);
